const PastaMass = [
  {
    id: 1,
    title: 'Паста з креветками у вершковому соусі 250г',
    price: '295 грн',
    src: require('../img/pastaztigrkrevsous.png'),
    text: 'Паста, тигрові креветки, вершки, лимон ',
    isNew: true,
    allergy: `🦐креветки, 🥛молоко (вершки,пармезан),🌾глютен (паста),🍋цитрус `
  },
  {
    id: 2,
    title: 'Паста з мідіями 300г',
    price: '295 грн',
    src: require('../img/pastamidii.png'),
    text: 'Паста,мідії,помідори черрі,петрушка ,часник. Паста в легкому винному соусі з часником та оливковою олією ',
    isNew: true,
    allergy: `🦪мідії,🌾глютен (паста)`
  },
  {
    id: 3,
    title: 'паста з креветками у винному соусі 300г',
    price: '325 грн',
    src: require('../img/krevetka.png'),
    text: 'Паста,тигрові креветки ,помідори черрі,петрушка ,часник.  Паста в легкому винному соусі з часником та оливковою олією ',
    isNew: true,
    allergy: `🦐креветки,🌾глютен (паста)`
  },
  {
    id: 4,
    title: 'Паста сирна 250г',
    price: '230 грн',
    src: require('../img/sirnayapasta.png'),
    text: 'Паста, вершки, сир дорблю, сир чеддер, сир пармезан, мигдальні горіхи',
    allergy: `🥛молоко (сири, вершки), 🌰 горіхи (мигдаль), 🌾глютен (паста)`
  },
  {
    id: 5,
    title: 'Паста з куркою і грибами 250г',
    price: '260 грн',
    src: require('../img/chikenpasta.webp'),
    text: 'філе куряче, паста, вершки, печериці, пармезан',
    allergy: `🍄‍🟫гриби ,🥛молоко (вершки, пармезан), 🌾глютен (паста)`
  },
  {
    id: 6,
    title: 'Паста «Карбонара» 250г',
    price: '260 грн',
    src: require('../img/karbonara.webp'),
    text: 'шинка, бекон, паста, вершки, пармезан, яєчний жовток',
    allergy: `🥛молоко (вершки, пармезан), 🌾глютен (паста)`
  },
  {
    id: 7,
    title: 'Паста з лососем 250г',
    price: '280 грн',
    src: require('../img/red-fish.webp'),
    text: 'лосось, паста, вершки, пармезан, лимон',
    allergy: `🐟лосось,🥛молоко (вершки, пармезан), 🌾глютен (паста)`
  },
];

export default PastaMass;
